import Head from 'next/head'

import Accordion from '@totallymoney/ui/components/Accordion'
import Box from '@totallymoney/ui/components/Box'
import Stack from '@totallymoney/ui/components/Stack'
import theme from '@totallymoney/ui/theme'

import BackgroundImageRenderer from '@components/BackgroundImageRenderer'

import useAppQueryState from '@hooks/useAppQueryState'

import warmYellowBackgroundTexture from '@images/warmYellow-bg.png'

import convertJsxToPlainText from '@utils/convertJsxToPlainText'

import { findingTheRightCardAccordions } from './lib/findingTheRightCardAccordions'

const FindingTheRightCardSection = () => {
    const { appQueryState } = useAppQueryState()
    const category = appQueryState.categoryId!

    const rightCardAccordions = findingTheRightCardAccordions[category]

    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            '@context': 'https://schema.org',
                            '@type': 'ItemList',
                            name: 'How to find the right credit card',
                            description:
                                'The best credit card for you will depend on what you want to use it for. For example, whether you want to pay down debt, improve your credit rating, spread the cost of a large purchase, spend overseas, or earn cashback.',
                            itemListOrder: 'Unordered',
                            itemListElement: [
                                rightCardAccordions.map(
                                    ({ heading, text }) => ({
                                        '@type': 'ListItem',
                                        name: heading,
                                        description:
                                            convertJsxToPlainText(text),
                                    })
                                ),
                            ],
                        }),
                    }}
                />
            </Head>

            <Box
                gridColumn="1/13"
                backgroundColor={theme.warmYellow60}
                borderRadius={[0, 'borderRadius20']}
                position="relative"
                overflow="hidden"
                mx={['-space30', 0]}
            >
                <Box position="absolute" width="100%" height="100%">
                    <BackgroundImageRenderer
                        backgroundMobile={warmYellowBackgroundTexture}
                        backgroundTabletPlus={warmYellowBackgroundTexture}
                        sizes="80vw"
                    />
                </Box>

                <Stack p={['space20', 'space40']} space="space20">
                    {rightCardAccordions.map(({ heading, text }, i) => (
                        <Accordion
                            // @ts-ignore
                            style={{ backgroundColor: 'white' }}
                            header={heading}
                            key={`${heading}-${i}`}
                            initialIsOpen={i === 0}
                        >
                            {text}
                        </Accordion>
                    ))}
                </Stack>
            </Box>
        </>
    )
}

export default FindingTheRightCardSection
